<div class="main">
    <h1>{{ data.message }}</h1>

    <div class="buttons">
        <button class="button button-orange" (click)="onConfirm()">Yes</button>
        <button class="button button-orange" (click)="onClose()">No</button>
    </div>
</div>